<template>
  <div id="grid-estado-visita">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex>
          <v-data-table
            :headers="headers"
            :items="visitaEstados"
            :rows-per-page-items="rowsPerPageItems"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">
                {{ props.item.tipoVisita.descripcion }}
              </td>
              <td class="text-xs-left">
                {{ props.item.estadoVisita.descripcion }}
              </td>
              <td class="text-xs-left">{{ props.item.fechaModificacion }}</td>
              <td class="text-xs-left">{{ props.item.author }}</td>
              <td class="text-xs-left">{{ props.item.observaciones }}</td>
              <v-btn
                v-if="props.item.tiene_documento == true"
                depressed
                outline
                title="Descargar documento"
                icon
                fab
                dark
                color="primary"
                small
                @click="downloadFile(props.item.id, props.item.filename)"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
export default {
  name: "grid-estado-visita",
  components: {
    LoadingDescarga,
  },
  props: {
    tipeView: "",
  },
  data() {
    return {
      dialogLoading: false,
      loading: false,
      dialog: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Tipo",
          align: "left",
          sortable: false,
          value: "tipoVisita",
        },
        {
          text: "Estado",
          align: "left",
          sortable: false,
          value: "estadoVisita",
        },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Usuario", sortable: false, value: "usuario" },
        { text: "Observacion", sortable: false, value: "observacion" },
        { text: "Accion", sortable: false, value: "documento" },
      ],
      visitaEstados: [],
      idVisita: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  mounted() {
    this.idVisita = this.$store.getters.visitaStored;
    this.tipeView = this.$route.params.tipeView;
    this.idContrato = this.$store.getters.contratoStored;
    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadDataVisitaEstados();
    }
  },
  computed: {},
  methods: {
    async loadDataVisitaEstados() {
      this.visitaEstados = await this.loadEstadosByVisit();
    },

    downloadFile(id, filename) {
      this.dialogLoading = true;
      let that = this;
      axios({
        url: "visita/download/" + id,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadEstadosByVisit() {
      let that = this;
      return await axios
        .get("/visita/" + this.idVisita + "/estados" + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
